// extracted by mini-css-extract-plugin
export var aiBadge = "ImageEnhancement-module--aiBadge--7ad88";
export var btn = "ImageEnhancement-module--btn--8967b";
export var btnGhost = "ImageEnhancement-module--btnGhost--35190";
export var btnLink = "ImageEnhancement-module--btnLink--013d4";
export var buildCell = "ImageEnhancement-module--buildCell--c3797";
export var buildGrid = "ImageEnhancement-module--buildGrid--eb20a";
export var buildIn = "ImageEnhancement-module--buildIn--3ed82";
export var capNotice = "ImageEnhancement-module--capNotice--ac8c3";
export var card = "ImageEnhancement-module--card--06517";
export var cardBorderless = "ImageEnhancement-module--cardBorderless--9b4b9";
export var cardGrid = "ImageEnhancement-module--cardGrid--7b05f";
export var cardHeader = "ImageEnhancement-module--cardHeader--0e446";
export var checkboxRow = "ImageEnhancement-module--checkboxRow--63da3";
export var disclaimer = "ImageEnhancement-module--disclaimer--516f9";
export var dropzone = "ImageEnhancement-module--dropzone--c8369";
export var dropzoneIcon = "ImageEnhancement-module--dropzoneIcon--9bd98";
export var dropzoneLabel = "ImageEnhancement-module--dropzoneLabel--6a9fe";
export var fadeMessage = "ImageEnhancement-module--fadeMessage--6454e";
export var footer = "ImageEnhancement-module--footer--3c0d8";
export var generatingMeta = "ImageEnhancement-module--generatingMeta--2399a";
export var headerImage = "ImageEnhancement-module--headerImage--dd37e";
export var helpText = "ImageEnhancement-module--helpText--c8f89";
export var heroBadge = "ImageEnhancement-module--heroBadge--8041f";
export var heroBox = "ImageEnhancement-module--heroBox--d10a9";
export var hiddenInput = "ImageEnhancement-module--hiddenInput--3987c";
export var imageBox = "ImageEnhancement-module--imageBox--3d94e";
export var inputBlock = "ImageEnhancement-module--inputBlock--4e225";
export var inputLabel = "ImageEnhancement-module--inputLabel--46845";
export var isActive = "ImageEnhancement-module--isActive--41d63";
export var isDone = "ImageEnhancement-module--isDone--7985e";
export var optionBody = "ImageEnhancement-module--optionBody--7b366";
export var optionCard = "ImageEnhancement-module--optionCard--7e014";
export var optionCardMulti = "ImageEnhancement-module--optionCardMulti--c499c";
export var optionDescription = "ImageEnhancement-module--optionDescription--00b2f";
export var optionImage = "ImageEnhancement-module--optionImage--912dc";
export var optionTick = "ImageEnhancement-module--optionTick--a231a";
export var optionTitle = "ImageEnhancement-module--optionTitle--8ee80";
export var outOfTries = "ImageEnhancement-module--outOfTries--4899f";
export var remaining = "ImageEnhancement-module--remaining--38463";
export var resultImage = "ImageEnhancement-module--resultImage--55c18";
export var root = "ImageEnhancement-module--root--43806";
export var rotatingMessage = "ImageEnhancement-module--rotatingMessage--15aee";
export var scan = "ImageEnhancement-module--scan--03981";
export var scanLine = "ImageEnhancement-module--scanLine--f3362";
export var select = "ImageEnhancement-module--select--eff4a";
export var selected = "ImageEnhancement-module--selected--e971b";
export var shimmer = "ImageEnhancement-module--shimmer--755f8";
export var skeleton = "ImageEnhancement-module--skeleton--ec463";
export var spin = "ImageEnhancement-module--spin--26aa8";
export var spinner = "ImageEnhancement-module--spinner--03b19";
export var stepper = "ImageEnhancement-module--stepper--b5164";
export var stepperDot = "ImageEnhancement-module--stepperDot--6714e";
export var subtitle = "ImageEnhancement-module--subtitle--ab72f";
export var textField = "ImageEnhancement-module--textField--586d6";
export var title = "ImageEnhancement-module--title--24a90";
export var toggle = "ImageEnhancement-module--toggle--a0397";
export var toggleOn = "ImageEnhancement-module--toggleOn--94ec4";
export var togglePill = "ImageEnhancement-module--togglePill--30d36";
export var toggleRow = "ImageEnhancement-module--toggleRow--c1718";
export var toggleThumb = "ImageEnhancement-module--toggleThumb--5c01c";
export var toggleTrack = "ImageEnhancement-module--toggleTrack--81655";
export var uploadSideBySide = "ImageEnhancement-module--uploadSideBySide--15487";
export var uploadSingle = "ImageEnhancement-module--uploadSingle--aa7b8";